export default __webpack_public_path__ + "static/media/emp3.cff3ef3b.png";